import { graphql } from '~/lib/graphql'

export const RestaurantAreaReviewRankingFragment = graphql(`
  fragment RestaurantAreaReviewRankingItem on RestaurantAreaReviewRanking {
    rank
    total
    minimumArea {
      code
      name
      parent {
        code
        parent {
          key
        }
      }
    }
  }
`)
